import { LabelValueModel } from '../../../../../models/label-value.model';
import { FotaUpdateTypeEnum } from '../enum/fota-update-type.enum';

export const fotaUpdateTypes: LabelValueModel[] = [
  { label: 'Regular', value: FotaUpdateTypeEnum.REGULAR },
  { label: 'Critical', value: FotaUpdateTypeEnum.CRITICAL },
  { label: 'Silent', value: FotaUpdateTypeEnum.SILENT },
];
